const UtmLocation = ( function() {
  let location = null;

  function init() {
    const urlParams = new URLSearchParams( window.location.search );
    if ( urlParams.has( 'utm_campaign' ) ) {
      const campaign = urlParams.get( 'utm_campaign' );
      location = window?.siteInfo?.locations.find( ( store ) => {
        return campaign.endsWith( `_${store.city}_${store.state}_${store.store_id}` );
      } );
    }

    return null;
  }

  function getLocation() {
    return location;
  }

  return {
    init: init,
    getLocation: getLocation,
  };
} )();

export default UtmLocation;
